import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function videoDataReducer(
  state = initialState.videoData,
  action
) {
  switch (action.type) {
    case types.LOADED_VIDEO_DATA_SUCCESS:
      return action.videoData;
    default:
      return state;
  }
}
